<template>
  <error text="PÁGINA NO ENCONTRADA" />
</template>

<script>
import error from "../../components/shared/error/error.vue";
export default {
  components: {
    error,
  },
  // name: "errorinfo",
};
</script>